export const COUNTRIES_MAP = {
  se: 'Sweden',
  nz: 'New Zealand',
  ie: 'Ireland',
  fi: 'Finland',
  no: 'Norway',
};
